import { Dropdown, Flex, Input, Menu, MenuProps, message, Radio, Space, Tooltip, Typography } from "antd";
import React, { FC, SetStateAction, useEffect, useState } from "react";
import { SvgIcon } from "src/shared/icons";
import { useDispatch, useSelector } from "react-redux";
import { closeAssigningArr, teamSelector, userSelector } from "src/store/user";
import { ConfirmButtons, CustomSelect, Modal } from "src/components/ui";
import { assignmentsToUpl, takeOffPopUpToUpdPros } from "src/store/outreach-campaigns/asyncRequests";

export const AssignedContacts: React.FC = () => {
  const { pros_uploaded_that_need_assigning, id: cliId } = useSelector(userSelector);
  // console.log(pros_uploaded_that_need_assigning, "pros_uploaded_that_need_assigning");

  const { clientWithTeam } = useSelector(teamSelector);
  const { pageInfo } = clientWithTeam;
  const [totalUpl, setTotalUpl] = useState(0);
  const [amntUnnasigned, setAmntUnnasigned] = useState(0);
  const [totalAlrAssigned, setTotalAlrAssigned] = useState(0);
  const [assignmentOption, setAssignmentOption] = useState("me");
  const [customAssignment, setCustomAssignment] = useState([{ id: cliId, from: 0, to: 0 }]);

  // if 0 do it
  // if 10 do it
  // if multi team mems take care of it

  useEffect(() => {
    const amntOfUnassigned = pros_uploaded_that_need_assigning?.find((pr) => pr?.team_mem_id === "unassigned")?.amnt || 0;
    setAmntUnnasigned(amntOfUnassigned);
    setTotalUpl(pros_uploaded_that_need_assigning?.reduce((sum, pr) => sum + (pr?.amnt || 0), 0) || 0);
    setTotalAlrAssigned(
      pros_uploaded_that_need_assigning?.filter((pr) => pr?.team_mem_id !== "unassigned")?.reduce((sum, pr) => sum + (pr?.amnt || 0), 0) || 0
    );
    setCustomAssignment([{ id: cliId, from: 0, to: amntOfUnassigned }]);
  }, [pros_uploaded_that_need_assigning]);
  // const [messageApi, contextHolder] = message.useMessage();

  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(closeAssigningArr());
    dispatch(takeOffPopUpToUpdPros());
  };
  const handleSubmitAssignment = () => {
    if (assignmentOption === "none") {
      handleClose();
      return;
    }
    dispatch(assignmentsToUpl({ assignmentOption, customAssignment, amntUnnasigned }));
    handleClose();
  };
  const handleAddTeamMem = () => {
    const nextCliHas = actTeamMems?.find((tm) => !customAssignment?.some((as) => as?.id === tm?.id));
    if (nextCliHas?.id) {
      setCustomAssignment((prev) => [...prev, { id: nextCliHas?.id, from: 0, to: amntUnnasigned }]);
    } else {
      message.info({
        content: "All team members added already",
        // push it above the modal’s 1000
        style: { zIndex: 1001 },
      });
    }
  };
  console.log(customAssignment, "customAssignment");
  const [actTeamMems, setActTeamMems] = useState([]);

  useEffect(() => {
    const ordered = [
      ...(pageInfo?.data?.team_members?.filter((tm) => tm.id === cliId) || []),
      ...(pageInfo?.data?.team_members?.filter((tm) => tm.id !== cliId) || []),
    ];
    // console.log(cliId, "cliIdcliId", pageInfo?.data?.team_members);
    // console.log(pageInfo?.data?.team_members, "pageInfo?.data?.team_members");
    setActTeamMems(ordered || []);
  }, [pageInfo?.data?.team_members]);

  return (
    <Modal
      open={pros_uploaded_that_need_assigning?.length}
      title={!totalUpl ? `No prospects we're uploaded` : `Assign prospects uploaded`}
      zIndex={1000}
      onCancel={handleClose}
    >
      {/* {contextHolder} */}
      <Typography.Paragraph>
        {amntUnnasigned && !totalAlrAssigned ? (
          ""
        ) : (
          <>
            {totalUpl} prospects were successfully uploaded. {!totalUpl ? `Deselect checkboxes before uploading if you want to reupload contacts.` : ""}
            {amntUnnasigned ? `Use this pop up to assign prospects to your team.` : ""}
            <br />
          </>
        )}
      </Typography.Paragraph>
      {totalAlrAssigned ? (
        <div>
          {totalAlrAssigned} prospects in your upload were already uploaded in the past and assigned.{" "}
          <Tooltip
            title={
              <>
                You can reassign these prospects in the CRM "Contacts" tab in Meetz. Just filter to show those prospects, select them, and reassign.
                <br />
                <br />
                Team members that had these prospects already assigned to them:
                <br />
                {pros_uploaded_that_need_assigning
                  ?.filter((pr) => pr?.team_mem_id !== "unassigned")
                  ?.map((pr) => {
                    const teamMemEmail = pageInfo?.data?.team_members?.find((tm) => tm?.id === pr?.id)?.email;
                    return (
                      <div>
                        <i>{teamMemEmail}: </i>
                        {pr?.amnt || 0}
                      </div>
                    );
                  })}
              </>
            }
          >
            {" "}
            <SvgIcon type={"tooltip"} style={{ marginLeft: 8, cursor: "pointer" }} />
          </Tooltip>
          <br />
          <br />
        </div>
      ) : (
        ""
      )}
      {amntUnnasigned ? (
        <>
          <div>Uploaded {amntUnnasigned} unassigned prospects that you can assign to yourself or your team members:</div>

          <div style={{ marginTop: 16 }}>
            <Radio.Group style={{ width: "100%", marginBottom: "25px" }} onChange={(e) => setAssignmentOption(e.target.value)} value={assignmentOption}>
              <Space direction={"vertical"}>
                <Radio value="me">Assign all uploaded prospects to me</Radio>
                <Radio value="none">
                  Don't assign prospects now
                  <Tooltip
                    title={`You can assign the prospects in the CRM "Contacts" tab at a later time. You will need to assign the prospects to yourself in order to use it in your campaign.`}
                  >
                    {" "}
                    <SvgIcon type={"tooltip"} style={{ marginLeft: 8, cursor: "pointer", margin: 0, height: "15px" }} />
                  </Tooltip>
                </Radio>
                <Radio value="custom">Assign to different team members as well</Radio>
              </Space>
            </Radio.Group>
            {/* do a plus and shit */}
            {assignmentOption === "custom" && (
              <div style={{ marginTop: 16 }}>
                <Typography.Paragraph>
                  Assign prospects to team members{" "}
                  <Tooltip
                    title={
                      <>
                        Assign prospects to activated team members, prospects that are not in the range will be left unassigned. Put in the range of prospects
                        in order to assign it to your team members.
                        <br />
                        <br />
                        Note: Overlaps will be ignored since only 1 prospect can be assigned to 1 team member. So make sure to assign 0-100, 101-200, ...{" "}
                      </>
                    }
                  >
                    {" "}
                    <SvgIcon type={"tooltip"} style={{ marginLeft: 8, cursor: "pointer", margin: 0, height: "15px" }} />
                  </Tooltip>
                  :
                </Typography.Paragraph>
                <br />
                {customAssignment.map((assign, idx) => (
                  <Flex key={idx} align="center" style={{ marginBottom: 8 }}>
                    <CustomSelect
                      placeholder="Select a team member"
                      value={assign.id}
                      options={actTeamMems
                        .map((tm) => ({
                          label: `${tm.first_name} ${tm.last_name} (${tm.email})`,
                          value: tm.id,
                        }))
                        ?.filter((opt) => !customAssignment?.some((cs) => opt?.value === cs?.id) || opt?.value === assign.id)}
                      onChange={(value) => setCustomAssignment((prev) => prev.map((item, i) => (i === idx ? { ...item, id: value } : item)))}
                      style={{ width: 200, marginRight: 8 }}
                      // isSearchSelect={false}
                    />

                    <Input
                      type="number"
                      min={0}
                      max={Math.min(assign.to - 1, amntUnnasigned - 1)}
                      value={assign.from}
                      onChange={(e) => {
                        const raw = Number(e.target.value);
                        const upper = Math.min(assign.to - 1, amntUnnasigned - 1);
                        const fromVal = raw < 1 ? 0 : raw > upper ? upper : raw;
                        setCustomAssignment((prev) => prev.map((item, i) => (i === idx ? { ...item, from: fromVal > 0 ? fromVal : 0 } : item)));
                        console.log(`Row ${idx} → from:`, fromVal);
                      }}
                      style={{ width: 80, marginRight: 8 }}
                      placeholder="From"
                    />
                    <Input
                      type="text"
                      value={assign.toRaw ?? String(assign.to)}
                      onChange={(e) => {
                        // allow only digits while typing
                        const digits = e.target.value.replace(/\D/g, "");
                        setCustomAssignment((prev) => prev.map((item, i) => (i === idx ? { ...item, toRaw: digits } : item)));
                      }}
                      onBlur={() => {
                        // once they leave, parse & clamp
                        const rawNum = Number(assign.toRaw ?? assign.to);
                        const lower = assign.from + 1;
                        const upper = amntUnnasigned;
                        const toVal = rawNum < lower ? lower : rawNum > upper ? upper : rawNum;
                        setCustomAssignment((prev) => prev.map((item, i) => (i === idx ? { ...item, to: toVal, toRaw: undefined } : item)));
                        console.log(`Row ${idx} → to:`, toVal);
                      }}
                      style={{ width: 80 }}
                      placeholder="To"
                    />
                  </Flex>
                ))}

                {customAssignment?.length > 1 ? (
                  <a style={{ display: "block", marginTop: 8 }} onClick={() => setCustomAssignment((prev) => prev.slice(0, -1))}>
                    - Remove team member
                  </a>
                ) : (
                  ""
                )}
                <a style={{ display: "block", marginTop: 8 }} onClick={handleAddTeamMem}>
                  + Add team member
                </a>
              </div>
            )}
          </div>

          <br />
          <ConfirmButtons leftButtonTitle={"Cancel"} onCancel={handleClose} rightButtonTitle={"Save"} handleSubmit={handleSubmitAssignment} />
        </>
      ) : (
        // <Typography.Paragraph>No .</Typography.Paragraph>
        ""
      )}
    </Modal>
  );
};
